type CountryRule = {
  country: string;
  countryCode: string;
  trunkPrefix?: string;
  localLength: number[];
  patterns?: RegExp[];
};

const countryRules: CountryRule[] = [
  {
    country: 'Bangladesh',
    countryCode: '880',
    trunkPrefix: '0',
    localLength: [10, 11],
    patterns: [/^01\d{9}$/, /^0\d{8,10}$/],
  },
  {
    country: 'India',
    countryCode: '91',
    trunkPrefix: '0',
    localLength: [10],
    patterns: [/^[6-9]\d{9}$/],
  },
  {
    country: 'United Kingdom',
    countryCode: '44',
    trunkPrefix: '0',
    localLength: [10],
    patterns: [/^7\d{9}$/, /^1\d{9}$/],
  },
  {
    country: 'United States',
    countryCode: '1',
    localLength: [10],
    patterns: [/^[2-9]\d{9}$/],
  },
];

export function toInternationalNumber(localNumber: string): string | null {
  const clean = localNumber.replace(/\D/g, '');

  for (const rule of countryRules) {
    const matchesLength = rule.localLength.includes(clean.length);
    const matchesPattern = rule.patterns?.some(re => re.test(clean)) ?? true;

    if (matchesLength && matchesPattern) {
      let normalized = clean;

      if (rule.trunkPrefix && clean.startsWith(rule.trunkPrefix)) {
        normalized = clean.slice(rule.trunkPrefix.length);
      }

      return `+${rule.countryCode}${normalized}`;
    }
  }

  return null;
}
